import { FaDiscord } from "react-icons/fa";
import { useDiscordWidget } from "../hooks/useDiscordWidget";

export default function DiscordCommunityIndicator() {
  const widget = useDiscordWidget();

  if (!widget) {
    return null;
  }

  const memberLabel = widget.presenceCount === 1 ? "member" : "members";

  return (
    <div
      className="mx-auto mt-6 inline-flex max-w-full flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-white/15 bg-slate-950/20 px-4 py-2 text-sm text-gray-200 shadow-sm"
      aria-live="polite"
    >
      <FaDiscord className="text-lg text-cyan-300" aria-hidden="true" />
      <span className="font-semibold text-white">Discord Community</span>
      <span className="text-gray-400" aria-hidden="true">|</span>
      <span>{widget.presenceCount} {memberLabel} online</span>
    </div>
  );
}
